<template>
  <div class="last-read-break">
    <div class="break-line"></div>
    <div class="break-content">
      <v-icon small class="mr-2" color="blue">mdi-check-all</v-icon>
      <span class="break-text">{{ breakText }}</span>
    </div>
    <div class="break-line"></div>
  </div>
</template>

<script>
export default {
  name: 'LastReadBreak',
  props: {
    unreadCount: {
      type: Number,
      default: 0
    },
    lastReadTime: {
      type: [Date, String],
      default: null
    }
  },
  computed: {
    breakText() {
      if (this.unreadCount > 0) {
        return `${this.unreadCount} unread message${this.unreadCount === 1 ? '' : 's'}`;
      }
      return 'All messages read';
    }
  }
};
</script>

<style scoped>
.last-read-break {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 16px 0;
  position: relative;
}

.break-line {
  flex: 1;
  height: 1px;
  background-color: #2196f3;
  max-width: 80px;
  opacity: 0.6;
}

.break-content {
  display: flex;
  align-items: center;
  background-color: #e3f2fd;
  color: #1976d2;
  font-size: 0.75rem;
  font-weight: 500;
  padding: 6px 12px;
  border-radius: 16px;
  margin: 0 12px;
  white-space: nowrap;
  border: 1px solid #bbdefb;
}

.break-text {
  font-size: 0.75rem;
  font-weight: 500;
}

@media (max-width: 600px) {
  .break-line {
    max-width: 50px;
  }
  
  .break-content {
    font-size: 0.7rem;
    padding: 4px 8px;
    margin: 0 8px;
  }
}
</style>
